import { apiClient } from './base';

export interface LoginCredentials {
  username: string;
  password: string;
}

export interface LoginResponse {
  access_token: string;
  token_type: string;
  user: {
    UserID: string;
    UserName: string;
    UserType: string;
    CompanyID: string;
    EmailAddress?: string;
    FirstName?: string;
    LastName?: string;
  };
}

export interface User {
  UserID: string;
  UserName: string;
  UserType: string;
  CompanyID: string;
  EmailAddress?: string;
  FirstName?: string;
  LastName?: string;
  JobTitle?: string;
  Mobile?: string;
  Phone?: string;
  /** Effective pour-type access (company licensing ∩ per-user restriction). */
  allowed_monitoring_functions?: string[];
  /** RBAC permission strings from the backend User Functions matrix. */
  permissions?: string[];
}

/**
 * Authentication API service
 */
export const authAPI = {
  /**
   * Login user with username and password
   */
  login: async (credentials: LoginCredentials): Promise<LoginResponse> => {
    const response = await apiClient.post('/auth/login', credentials);
    return response.data;
  },
  
  /**
   * Get current authenticated user info
   */
  getCurrentUser: async (): Promise<User> => {
    const response = await apiClient.get('/auth/me');
    return response.data;
  },
  
  /**
   * Logout current user
   */
  logout: async (): Promise<void> => {
    await apiClient.post('/auth/logout');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },

  /**
   * Login as another user (Super Admin only)
   */
  loginAsUser: async (userId: string): Promise<LoginResponse> => {
    const response = await apiClient.post('/auth/login-as-user', { user_id: userId });
    return response.data;
  }
};